export const AwardTypesEnum = {
  ManualAtStation: "manual-at-station",
  PriceLOCQ: "pricelocq",
  ManualAtAdmin: "manual-at-admin",
};
